import React from "react";
import { useHistory } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

const UserDropdown = () => {
  // dropdown props
  const [dropdownPopoverShow, setDropdownPopoverShow] = React.useState(false);
  const btnDropdownRef = React.useRef();
  const popoverDropdownRef = React.useRef();
  const { user, logout } = useAuth();
  const history = useHistory();
  
  const toggleDropdown = () => {
    setDropdownPopoverShow(!dropdownPopoverShow);
  };

  // Close dropdown when clicking outside
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownPopoverShow &&
        btnDropdownRef.current &&
        popoverDropdownRef.current &&
        !btnDropdownRef.current.contains(event.target) &&
        !popoverDropdownRef.current.contains(event.target)
      ) {
        setDropdownPopoverShow(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownPopoverShow]);

  const handleLogout = async () => {
    await logout();
    history.push('/auth/login');
  };
  return (
    <div className="relative">
      <a
        className="text-blueGray-500 block"
        href="#pablo"
        ref={btnDropdownRef}
        onClick={(e) => {
          e.preventDefault();
          toggleDropdown();
        }}
      >
        <div className="items-center flex">
          <span className="w-12 h-12 text-sm text-white bg-blueGray-200 inline-flex items-center justify-center rounded-full">
            <span className="text-blueGray-700 font-semibold">
              {user?.name?.charAt(0)?.toUpperCase() || 'U'}
            </span>
          </span>
        </div>
      </a>
      <div
        ref={popoverDropdownRef}
        className={
          (dropdownPopoverShow ? "block " : "hidden ") +
          "bg-white text-base z-50 absolute right-0 top-full py-2 list-none text-left rounded shadow-lg min-w-48 mt-1 border border-gray-200"
        }
      >
        <div className="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700 border-b border-blueGray-100">
          <div className="font-semibold">{user?.name}</div>
          <div className="text-xs text-blueGray-500">{user?.email}</div>
          {user?.admin && (
            <div className="text-xs text-blue-600 font-semibold">Administrator</div>
          )}
        </div>
        <div className="h-0 my-2 border border-solid border-blueGray-100" />
        <a
          href="#"
          className={
            "text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700 hover:bg-blueGray-100"
          }
          onClick={(e) => {
            e.preventDefault();
            handleLogout();
          }}
        >
          <i className="fas fa-sign-out-alt mr-2"></i>
          Logout
        </a>
      </div>
    </div>
  );
};

export default UserDropdown;
